/* One alternating colour sequence for editorial section titles, in page order. */
(() => {
  const selector = [
    'h1', 'h2', '.product-calm-panel-heading h3',
    '.product-calm-closing h3', '.product-calm-deck__heading'
  ].join(',');
  const excluded = [
    '.product__info-container', '.product__title', '.card', '.card-wrapper',
    '.mimu-values-strip', '.jdgm-widget', '.shopify-app-block',
    '.article-template__content', '.about-mimu__cta',
    'summary', 'dialog', '[role="dialog"]', '.visually-hidden',
    '.form-status', '[data-mimu-solid-heading]'
  ].join(',');

  function applyHeadingColours() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    let index = 0;
    main.querySelectorAll(selector).forEach((heading) => {
      const reviewSectionTitle = heading.matches('.jdgm-title');
      if ((!reviewSectionTitle && heading.closest(excluded)) || !heading.textContent.trim()) return;
      if (heading.closest('[hidden], [aria-hidden="true"]') ||
          getComputedStyle(heading).display === 'none') return;
      let text = heading.querySelector(':scope > .mimu-section-heading__text');
      if (!text) {
        text = document.createElement('span');
        text.className = 'mimu-section-heading__text';
        while (heading.firstChild) text.appendChild(heading.firstChild);
        heading.appendChild(text);
      }
      heading.classList.add('mimu-section-heading');
      heading.dataset.mimuHeadingOrder = index++ % 2 ? 'green-first' : 'terracotta-first';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeadingColours, { once: true });
  } else {
    applyHeadingColours();
  }
  document.addEventListener('shopify:section:load', applyHeadingColours);
  document.addEventListener('shopify:section:unload', applyHeadingColours);
  document.addEventListener('shopify:section:reorder', applyHeadingColours);
  window.addEventListener('load', applyHeadingColours, { once: true });
})();
